import React, { FC } from "react";
import { TextField as MuiTextField } from "@mui/material";

type Props = React.ComponentProps<typeof MuiTextField>;
const TextFields: FC<Props> = (props) => {
    return <MuiTextField variant="standard" {...props}/>;
}

export default TextFields;